import React from 'react';
const tomes = [{
  number: '01',
  title: 'Reflejos y Vínculo',
  desc: 'Desarrollo neurológico, apego y estimulación temprana del recién nacido'
}, {
  number: '02',
  title: 'Exploración Sensorial',
  desc: 'Integración sensorial, juego y estimulación multisensorial'
}, {
  number: '03',
  title: 'Primeros Pasos',
  desc: 'Desarrollo motor, equilibrio y conquista del espacio'
}, {
  number: '04',
  title: 'Lenguaje y Juego',
  desc: 'Adquisición del lenguaje, comunicación y juego simbólico'
}, {
  number: '05',
  title: 'Motricidad Fina',
  desc: 'Coordinación visomotora, pinza y habilidades manuales'
}, {
  number: '06',
  title: 'Autonomía y Social',
  desc: 'Independencia, vínculos con pares y preparación para el jardín'
}];
const includes = ['Scripts listos para copiar y usar hoy', 'Fichas imprimibles por etapa', 'Checklists de seguimiento por tomo', 'Protocolos de alerta y derivación', 'Guiones para familias y cuidadores', 'Planificación semanal y mensual', 'Marco teórico de neurodesarrollo', '100% adaptado al profesional argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(240,249,255) 15%, rgb(240,249,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-361">
      <div className="mx-auto max-w-4xl" data-id="element-362">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-363">
          Lo que <span className="text-cyan-brand" data-id="element-364">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-365">
          6 tomos · +380 páginas · Todo listo para implementar
        </p>

        {/* Tomos */}
        <div className="bg-white border border-cyan-brand/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-366">
          {/* Header */}
          <div className="bg-cyan-brand px-5 py-3" data-id="element-367">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-368">
              👶 LOS 6 TOMOS — Para profesionales de Estimulación Temprana
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-369">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-370">
                {/* Número */}
                <span className="shrink-0 text-lg font-black text-cyan-brand/30 w-8 text-center" data-id="element-371">
                  {tome.number}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-372">
                  <span className="block text-sm font-black text-gray-900" data-id="element-373">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-374">
                    {tome.desc}
                  </span>
                </div>

                {/* Páginas */}
                <span className="shrink-0 text-[10px] font-bold text-cyan-brand bg-cyan-brand/5 border border-cyan-brand/20 rounded-full px-2 py-0.5" data-id="element-375">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="bg-white border border-cyan-brand/20 rounded-xl overflow-hidden shadow-sm" data-id="element-376">
          {/* Header */}
          <div className="bg-cyan-brand/5 border-b border-cyan-brand/20 px-5 py-3" data-id="element-377">
            <h3 className="text-sm font-black text-cyan-brand m-0" data-id="element-378">
              Cada tomo incluye:
            </h3>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-379">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-380">
                <span className="shrink-0 text-cyan-brand font-bold text-sm mt-0.5" data-id="element-381">
                  ✅
                </span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-382">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}